import React, { SyntheticEvent } from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'volume-full';

const originalDimensions = {
    width: 24,
    height: 24,
};

// stockholm-icon-set/Media/Volume-full.svg

export const IconVolumeFull = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses, handleClick } = props;
    const classNames = cx(addClasses, 'inline', {
        'cursor-pointer': handleClick,
    });

    return (
        <svg
            aria-labelledby={iconId}
            className={classNames}
            height={height}
            onClick={(e: SyntheticEvent): void => {
                if (handleClick) {
                    handleClick(e);
                }
            }}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Speaker at Full Volume Icon</title>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M16.316 16.148a.75.75 0 01-.733-1.309A3.248 3.248 0 0017.25 12a3.248 3.248 0 00-1.645-2.827.75.75 0 01.742-1.304A4.748 4.748 0 0118.75 12c0 1.74-.944 3.315-2.434 4.148zm.473 3.741a.75.75 0 01-.65-1.352A7.25 7.25 0 0020.25 12a7.25 7.25 0 00-4.044-6.505.75.75 0 11.664-1.344A8.75 8.75 0 0121.75 12a8.75 8.75 0 01-4.961 7.89z"
                    fill={fill}
                    fillRule="nonzero"
                    opacity=".3"
                />
                <path
                    d="M7 16l-3.392-.678A2 2 0 012 13.36v-2.72a2 2 0 011.608-1.962L7 8l3.293-3.293A1 1 0 0112 5.414v13.172a1 1 0 01-1.707.707L7 16z"
                    fill={fill}
                />
            </g>
        </svg>
    );
};
